import normalizeText from 'normalize-text';

export const sanitiseFileName = (fileName: string) => {
    const newFileName = removeAccents(fileName)
        .replace(/"'/g, '')
        .replace(/[$!*<>#%\\{}|^~[\]()`;,:?@=&]/g, '_')
        .replace(/ /g, '_');

    return newFileName;
};

const removeAccents = (input: string) => normalizeText(input
    .replace(/[\u0300-\u036f]/g, '')
    .split('')
    .map(letter => (letter === 'ß') ? 'ss' : letter)
    .join(''));
